import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import fetchRetry from '../fetchRetry';
import { FETCH_INTEGRATION_CREDENTIAL_SUCCESS } from './types';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const fetchIntegrationCredentialSuccess = data => ({
  type: FETCH_INTEGRATION_CREDENTIAL_SUCCESS,
  payload: data,
});

/**
 * fetches a single credential for Edit modal
 * @param {String} orgId - sinatra org id
 * @param {Object} id - internal_id from a preselected cred
 */

export const fetchIntegrationCredential = (orgID, id) => () => {
  try {
    return fetchRetry(`${baseURL}/psaps/${orgID}/authority-credentials/${id}`)
      .then(checkStatus)
      .then(parseJSON)
      .then(response => response);
  } catch (error) {
    return error;
  }
};

export default fetchIntegrationCredential;
